import { FoodIcon } from './FoodIcon';

/**
 * author: Google
 * id 140954DE-20F5-4A8B-BFC3-DB8E49922AF3
 * name food
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food.svg
 * tags
 * - Food / Drink 
 */
export const BurgerIcon = FoodIcon;
export default BurgerIcon